import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { websiteBuilderZLayers } from "pages/secure/facility/websiteBuilder/editor/websiteBuilderZLayers";
import React from "react";

interface ISectionViewResizeHandleProps {
  hovered: boolean;
  grabbing: boolean;
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
}

export function SectionViewResizeHandle(props: ISectionViewResizeHandleProps) {
  const { hovered, grabbing, onPointerDown } = props;

  return (
    <>
      {hovered && (
        <div
          className={classNames("website-builder-section-view-resize-handle", {
            "section-view-resize-handle-grabbing": grabbing,
          })}
          style={{
            zIndex: websiteBuilderZLayers.designSpace.sectionEditorUI,
          }}
          onPointerDown={onPointerDown}
        >
          <FontAwesomeIcon icon={faGripDotsVertical} />
        </div>
      )}
    </>
  );
}
